import * as React from "react";
const SvgFiRrVisit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-visit_svg__a)">
      <path
        fill="#062147"
        d="M13 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h6c2.757 0 5 2.243 5 5v5a1 1 0 0 1-2 0V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h7a1 1 0 0 1 1 1M6 13H5a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m5 0h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m-5 4H5a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m5 0h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2M6 5H5a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m5 0h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2M6 9H5a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m5 0h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m11.389 12.389-1.84 1.8a2.92 2.92 0 0 1-2.049.829 2.92 2.92 0 0 1-2.049-.829l-1.833-1.792c-2.152-2.152-2.152-5.642-.008-7.786A5.46 5.46 0 0 1 18.499 12c1.469 0 2.85.572 3.889 1.61a5.506 5.506 0 0 1 .001 7.779m-1.414-6.364A3.48 3.48 0 0 0 18.5 14c-.934 0-1.814.364-2.475 1.025a3.504 3.504 0 0 0 0 4.95l1.825 1.784a.935.935 0 0 0 1.301 0l1.833-1.792a3.5 3.5 0 0 0-.009-4.942m-2.475.969a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-visit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVisit;
